export enum SHEET_COLUMN_TYPE {
  NORMAL,
  JOIN,
}
